<template>
  <!-- 第一层嵌套 -->
  <!-- <div>
    <template v-if="obj.type===1">
      <div :style="{dispaly:visi?'block':'none'}">
        <span class="btn"
              @click.stop="shousuo">[x]</span>
        <span>[x]</span>
        <span :dataid='obj.module_uuid'>模块： {{obj.module_name}}</span>
      </div>
    </template>

    <template v-if="obj.function_button">
      <div style="margin-left:50px">
        <span>[x]</span>
        <span>[x]</span>
        <span :dataid='obj.function_uuid'> 功能模块:{{obj.function_name}}</span>
      </div>
    </template>

    <template v-if="obj.type===3">
      <div style="margin-left:150px">
        <span>[x]</span>
        <span>[x]</span>
        <span :dataid='obj.button_uuid'>按钮名称：{{obj.button_name}}</span>
      </div>
    </template>

    <template v-if="obj.children">
      <two v-for="item in obj.children"
           :key='item.module_uuid'
           :obj='item'></two>
    </template>

    <template v-if="obj.module_function">

      <two v-for="item in obj.module_function"
           :key='item.function_uuid'
           :obj='item'></two>
    </template>

    <template v-if="obj.function_button">
      <two v-for="item in obj.function_button"
           :key='item.button_uuid'
           :obj='item'></two>
    </template>

  </div> -->
  <div @click.stop="showChildren">
    <div class="two-content">
      <div>
        <span>[]</span>
        <span>x</span>
      </div>
      <div>
        <v-icon>></v-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'two',
  components: {},
  props: {
    obj: {
      type: Object
    },
  },
  data () {
    return {
      showChildren: false
    };
  },
  created () { },
  mounted () { },
  methods: {
    toggleChildren () {
      this.showChildren = !this.showChildren
    }
  },
  computed: {
    paddingLeft () {
      return this.level * 15 + 'px'
    }
  },
  watch: {},
};
</script>

<style scoped>
</style>
